export default __webpack_public_path__ + "static/media/rabbit-end-left.df0269f9.png";